export default "__VITE_ASSET__DetsUtDe__"